import { supabase } from './supabase.js'
import { getEmpresaId } from './syncManager.js'

export async function addAuditLog({ usuarioId, usuarioNome, acao, detalhes, tabelaAfetada, registroId }) {
  const empresaId = getEmpresaId()
  if (!empresaId) return // super admin sem empresa — não grava audit
  // Verificar se há sessão Supabase (JWT) — login local fallback não tem
  const { data: { session: supaSession } } = await supabase.auth.getSession()
  if (!supaSession) return
  const row = {
    id: crypto.randomUUID(),
    data_hora: Date.now(),
    usuario_id: usuarioId ?? null,
    usuario_nome: usuarioNome ?? null,
    empresa_id: empresaId,
    acao,
    detalhes: typeof detalhes === 'string' ? detalhes : JSON.stringify(detalhes ?? null),
    tabela_afetada: tabelaAfetada ?? null,
    registro_id: registroId ?? null
  }
  const { error } = await supabase.from('audit_logs').insert(row, { returning: 'minimal' })
  if (error) {
    console.warn('[AUDIT] Falha ao registrar no Supabase (audit_logs).', error.message)
  }
}
